import React, { createContext, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
/**
 * Global company details context.
 */
export const FlashMessagesContext = createContext();

export function FlashMessagesProvider({ children }) {
  const [flashMessages, setFlashMessages] = useState([]);

  const { t } = useTranslation();
  /**
   *
   * flashMessage.text can be a string, an array, or a function.
   *
   * Text type of string is either an already translated text, or translation key
   * Text type of an array, 0=translation key 1=translation params
   * Text type of a function, returns a translated text or a translation key
   *
   * @param {object} flashMessage
   * @param  {...any} params passed to the flashMessage.text function
   */
  function addFlashMessage(flashMessage, ...params) {

    const text = typeof (flashMessage.text) === 'function' ? flashMessage.text(...params) : flashMessage.text;

    const translatedText = Array.isArray(text) ? t(text[0], text[1]) : t(text);

    const key = flashMessage.variant + '-' + flashMessage.text;

    if (flashMessages.some(msg => msg.key === key)) {
      return;
    }

    const flashMessageWithParams = { variant: flashMessage.variant, text: translatedText, key, params };

    flashMessageWithParams.onClose = (msg) => {

      // If only one is left, then it must the one to be removed
      if ( flashMessages.length === 1 ) {
        setFlashMessages(flashMessages=>[]);
        return;
      }

      setFlashMessages(flashMessages => [...flashMessages.filter(fm => fm.key !== msg.key)]);
    };

    setFlashMessages(flashMessages => {
      return [...flashMessages, flashMessageWithParams];
    });
  }

  return (
    <FlashMessagesContext.Provider value={{ flashMessages, addFlashMessage }}>
      {children}
    </FlashMessagesContext.Provider>
  );
}

/**
 * Convenience hook providing {@see FlashMessagesContext} to function components.
 */
export function useFlashMessages() {
  return useContext(FlashMessagesContext);
}
